/* fetch polyfill for IE */
if(window) {
  require('whatwg-fetch');
}

const testingLocally = typeof location != 'undefined' && location.port === '3000';

export default {
  getPageContents: function(pageId) {
    let url = `${matrixData.urlPageContentsService}?page=${pageId}`;
    console.log(`SERVICE: ${url}`);
    return fetch(testingLocally ? '/mysource_files/sample-answer-content.json' : url, {
        credentials: "same-origin"
      }).then(response => {
        if (response.ok) {
          return response.json()
        } else {
          return Promise.reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      })
  },
}